import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { classNames } from "../../../../../general/functions/propsComponent";
import { PencilSquare } from "react-bootstrap-icons";
import TextAreaQuill from "../../../../../general/components/Textarea/Quilljs/TextAreaQuill";
import {
  GetListAnswerAssessee,
  SetAnswerAssessee,
} from "../../../actions/answerAssesseeActions";
import useDataSession from "../../../customeHooks/useDataSession";

export default function ModalTextAnswer(props) {
  const { handleChoosen } = props;
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [state, setState] = useState({ value: null });
  const { dataSession } = useDataSession();
  useEffect(() => {
    dispatch(GetListAnswerAssessee());
  }, []);

  const dispatch = useDispatch();

  const handleChange = (value) => {
    setState({ value });
  };
  //   const dispatch = useDispatch();
  const storeGet = useSelector((state) => state.smvm_get_list_answer_assessee);
  useEffect(() => {
    if (storeGet.success) {
      setLoading(false);
      handleChange(
        storeGet.data.find((x) => x.email == dataSession?.user?.email)
          ?.submission
      );
    }
    if (storeGet.error) {
      console.log("Get Answer Error", storeGet);
    }
  }, [storeGet]);
  const storeSet = useSelector((state) => state.smvm_set_answer_assessee);
  useEffect(() => {
    if (storeSet.success) {
      setLoading(false);
      setShowModal(false);
    }
    if (storeSet.error) {
      console.log("Set Answer Error");
      console.log("Set Answer Error", storeSet);
    }
  }, [storeSet]);
  const handleSave = () => {
    setLoading(true);
    dispatch(SetAnswerAssessee(state.value));
  };

  return (
    <>
      <button
        className={classNames(
          "btn-secondary  p-2 w-16 flex flex-col justify-center items-center whitespace-nowrap"
        )}
        onClick={() => {
          setShowModal(true);
        }}
      >
        <PencilSquare size={16} />
        <p className="text-xs font-normal">Answer</p>
      </button>
      {showModal ? (
        <>
          <div className="backdrop-filter backdrop-blur-sm justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative  my-6 mx-auto w-4/5 max-w-5xl">
              {/*content*/}
              <div className="border-t-8  rounded-md border-gray-100 shadow-lg relative flex flex-col w-full bg-secondary-500 outline-none focus:outline-none ">
                {/*header*/}
                <button
                  className="absolute top-2 right-4 p-1 ml-auto bg-transparent border-0 text-black opacity-4 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={() => setShowModal(false)}
                >
                  <span className="bg-transparent text-white opacity-75 h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
                <div className="flex items-start justify-between pt-10 px-10 pb-0 ">
                  <h3 className="text-3xl font-semibold  text-white ">
                    Answer
                  </h3>
                </div>

                {/*body*/}
                <div className="relative px-10 py-4  flex-auto ">
                  <div style={{ height: "" }} className="bg-white">
                    <TextAreaQuill
                      value={state.value}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 rounded-b gap-1">
                  <button
                    className="btn-secondary"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn-primary"
                    type="button"
                    onClick={() => {
                      handleSave();
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
